<app-header ng-non-bindable></app-header>
<main>
    <app-menu ng-non-bindable></app-menu>
    <div *ngIf="alert" ng-non-bindable><alert-aba-component/>
    </div> 

</main>
